import React,{FC,useState,useEffect,useRef} from 'react';
import {useNavigate,useLocation,HashRouter,Routes,Route,useParams} from 'react-router-dom';
import logo from './logo.svg';
import { useThrottleFn } from 'ahooks'
import { Button, NavBar, TabBar,SearchBar,Toast,List,Form,IndexBar,Popup } from 'antd-mobile'
import {
    AppOutline,
    MessageOutline,
    UnorderedListOutline,
    UserOutline,LeftOutline
} from 'antd-mobile-icons'
import './App.css';
import './demo2.css'
import axios from 'axios';
import Bottom from "./Bottom";
const ShowItems: FC = (props) => {
    const [tabs,setTabs]=useState([] as any);
    const [art, setArt] = useState(null);
    const navigate=useNavigate();
    const mainElementRef = useRef<HTMLDivElement>(null);
    const [form]=Form.useForm();
    let params = useParams();
    useEffect(()=>{
        let items=[

        ];
        Toast.show({icon:'loading',content:'加载中...',maskClickable: false,duration:30000});
        // @ts-ignore
        axios({
            method:'post',url:'/data/shl/partitems',data:{id:params.id},reponseType:'json'
        }).then(function(response){
            Toast.clear();
            let json=response.data;
            if(json.success){
                let items=[];
                let idx=0;
                let activeKey='';
                setTabs(json.data.items);
                if(json.data.items.length==0){
                    Toast.show({icon:'fail',content:"未查询到相关信息，请更换搜索词后再次尝试查询"});
                }
            }else{
                Toast.show({icon:'fail',content:json.message});
            }
        }).catch(function(error){
            console.log(error)
            Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
        });
    },[]);
    const searchMedicine = (val:string) =>{
        Toast.show({icon:'loading',content:'搜索中...',maskClickable: false,duration:30000});
        // @ts-ignore
        axios({
            method:'post',url:'/data/shl/partitems',data:{part_id:params.id,keywords:val},reponseType:'json'
        }).then(function(response){
            Toast.clear();
            let json=response.data;
            if(json.success){
                let items=[];
                let idx=0;
                let activeKey='';
                setTabs(json.data.items);
                if(json.data.items.length==0){
                    Toast.show({icon:'fail',content:"未查询到相关信息，请更换搜索词后再次尝试查询"});
                }
            }else{
                Toast.show({icon:'fail',content:json.message});
            }
        }).catch(function(error){
            console.log(error)
            Toast.show({icon:'fail',content:'系统错误，请稍候再试'});
        });
    }

    return (<div className='app'>
        <Popup
            visible={art==null?false:true}
            onMaskClick={() => {
                setArt(null)
            }}
            position='right'
            bodyStyle={{ width: '100vw' }}
        >
            {art?<><div className='top'>
                <NavBar onBack={()=>{ setArt(null); }}>条文详情</NavBar>
            </div>
                <div className='body page-prescription'>
                    <div className='art-content'>
                        <div className="part-name" dangerouslySetInnerHTML={{__html:art.part_name}} />
                        <div className="original" dangerouslySetInnerHTML={{__html:art.original}} />
                        {art.translated?<div className="translated" dangerouslySetInnerHTML={{__html:art.translated}} />:<></>}
                        {art.chufang?<div className="chufang" dangerouslySetInnerHTML={{__html:art.chufang}} />:<></>}
                        {art.nihaixia?<div className="nihaixia" dangerouslySetInnerHTML={{__html:art.nihaixia}} />:<></>}
                        {art.anli?<div className="anli" dangerouslySetInnerHTML={{__html:art.anli}} />:<></>}
                        {art.zhenjiu?<div className="zhenjiu" dangerouslySetInnerHTML={{__html:art.zhenjiu}} />:<></>}
                        {art.other?<div className="other" dangerouslySetInnerHTML={{__html:art.other}} />:<></>}

                    </div>
                    <div className="footer-back-icon">
                        <LeftOutline style={{ fontSize: 28, color:'var(--adm-color-primary)' }} onClick={()=>{ setArt(null); }} />
                    </div>
                </div></>:<></>}
        </Popup>
        <><div className='top'>
            <NavBar onBack={()=>{ navigate(-1); }}>伤寒论条辨</NavBar>
        </div>
        <div className='body page-prescription show-footer'>
            <div>
                <Form form={form} className="searchform" layout='horizontal'>
                    <Form.Item
                        name="searchText"
                        label={null}
                        extra={
                            <div>
                                <Button size='small' onClick={()=>{
                                    //let val = searchRef.current?.value;
                                    let val=form.getFieldValue("searchText");
                                    if(typeof(val)!="undefined"){
                                        searchMedicine(val);
                                    }
                                }}>搜索</Button>
                            </div>
                        }
                    >
                        <SearchBar placeholder='' clearable onSearch={(val)=>{ searchMedicine(val);  }} />
                    </Form.Item>
                </Form>
            </div>
            <div className="artlist " style={{width:'100%',height: window.innerHeight-153}}>
                <div className="part-items">
                            {tabs&&tabs.map(art => (
                                <div key={art.id} className='part-items-item' onClick={()=>{ setArt(art); } } dangerouslySetInnerHTML={{__html:art.original}}></div>
                            ))}
                </div>

                </div>
            <div className="footer-back-icon">
                <LeftOutline style={{ fontSize: 28, color:'var(--adm-color-primary)' }} onClick={()=>{ navigate(-1); }} />
            </div>
        </div></>
        <div className='bottom'>
            <Bottom></Bottom>
        </div>
    </div>)
}

export default  ShowItems;